import Vue from "vue";
import Vuex from 'vuex'
import authentication from './auth'
import message from './message'
import config from './config'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        authentication,
        message,
        config
    }
})
